import { SearchIcon } from '@heroicons/react/outline';
import { createBaseColumn } from '../../utils/columnUtils';
import { TableTemplate } from '../../types';

export const instagramProspectingTemplate: TableTemplate = {
  id: 'instagram_prospecting',
  name: 'Instagram Prospecting',
  description: 'Research and analyze Instagram creators for your campaigns',
  icon: SearchIcon,
  iconName: 'SearchIcon',
  variant: 'gradient',
  defaultConfig: {
    columns: [
      createBaseColumn('followers_count', 'Followers', {
        cell_type: 'normal',
        prompt: 'Get this creator\'s follower count specifically from their Instagram account only. Do not use follower data from TikTok, YouTube, or other platforms.',
        data_type: 'number',
        platform_resources: [{ platform: 'instagram', type: 'social_media' }]
      }),
      createBaseColumn('engagement_rate', 'Engagement Rate', {
        cell_type: 'normal',
        prompt: 'What is the creator\'s engagement rate on Instagram? Analyze their recent posts to calculate the engagement rate by dividing the total number of likes and comments by their follower count, then multiply by 100 to express it as a percentage.',
        data_type: 'percentage',
        platform_resources: [{ platform: 'instagram', type: 'social_media' }]
      }),
      createBaseColumn('avg_likes', 'Average Likes', {
        cell_type: 'normal',
        prompt: 'Calculate the average number of likes per post specifically from this creator\'s Instagram account. Analyze their recent 5 Instagram posts only, do not include likes from other platforms.',
        data_type: 'number',
        platform_resources: [{ platform: 'instagram', type: 'social_media' }]
      }),
      createBaseColumn('content_type', 'Content Type', {
        cell_type: 'normal',
        prompt: 'Analyze what type of content this creator posts specifically on Instagram. Categories might include: lifestyle, fashion, beauty, fitness, food, travel, photography, reels, stories, IGTV, etc. Focus only on their Instagram content style and format.',
        data_type: 'text',
        platform_resources: [{ platform: 'instagram', type: 'social_media' }]
      })
    ]
  }
};
